import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {withExperiments} from 'wix-experiments-react';
import '../../styles/message.scss';
import get from 'lodash/get';
import {resendMessage} from '../../actions';
const moment = require('moment');

class Message extends React.Component {

  componentDidMount() {
    if (this.props.message.dateTime) {
      this.forceUpdate();
    }
  }

  componentDidUpdate() {
    setTimeout(this.forceUpdate.bind(this), 60000);
  }

  urlify(text = '') {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const textParts = text.split(urlRegex);
    function isUrlPart(i) {
      return i % 2 === 0;
    }
    return textParts.map((part, i) => isUrlPart(i) ? part : <a href={part} target="_blank" rel="noopener noreferrer">{part}</a>);
  }

  render() {
    const {message, isLastInSequence, chatSettings, experiments} = this.props;
    const isIncomingMessage = () => {
      return message.direction === 'BUSINESS_TO_CUSTOMER';
    };

    const messageStyle = {
      borderRadius: get(chatSettings, 'design.selectedRadiusOption')
    };

    const getErrorFooter = () =>
      <span className="message-error">
        <span>Not Delivered</span>
        <span onClick={() => this.props.resendMessage(message)}>Try again</span>
      </span>;


    const getMessageFooter = message => {
      const date = message.dateTime && moment(message.dateTime).fromNow();
      if (message.error) {
        return getErrorFooter();
      }
      if (!message.error && !message.dateTime) {
        return <span className="sending-loader"/>;
      }
      return isLastInSequence ? <span className="message-date">{date}</span> : null;
    };

    const className = `message ${isIncomingMessage() ? 'in' : 'out'}`;

    const avatarStyle = get(chatSettings, 'design.selectedImageOption') === '3' ? {background: `url("${chatSettings.design.customImgUrl}")`} : {};

    const messageContent = experiments.enabled('specs.com.LinksInChat') ? this.urlify(message.content) : message.content;

    return (
      <div className={className}>
        <div className="message-top-row">
          {isLastInSequence ? <span className="avatar" style={avatarStyle}/> : null}
          <div className="message-content" style={messageStyle}>{messageContent}</div>
        </div>
        {getMessageFooter(message)}

      </div>
    );
  }
}

Message.propTypes = {
  message: PropTypes.object,
  isLastInSequence: PropTypes.bool,
  chatSettings: PropTypes.object,
  resendMessage: PropTypes.func,
  experiments: PropTypes.any
};

function mapStateToProps(state) {
  return {
    chatSettings: state.chatSettings
  };
}

const mapDispatchToProps = dispatch => ({resendMessage: message => dispatch(resendMessage(message.content.trim(), message.activityId))});

export default withExperiments(connect(mapStateToProps, mapDispatchToProps)(Message));



// WEBPACK FOOTER //
// ./chat-app/components/Message/Message.js